<template>
  <div class="fullPage">
    <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
      <v-card>
        <form>
          <v-card-title>
            <div>
              <div class="headline">Member Group Information</div>
            </div>
            <v-spacer></v-spacer>
            <div slot="action" v-if="!newMemberGroup">
              <v-tooltip top>
                <v-btn slot="activator" icon @click="doQuery">
                  <v-icon color="primary">mdi-magnify</v-icon>
                </v-btn>
                <span>Query Member Group</span>
              </v-tooltip>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6 v-if="newMemberGroup">
                    <v-text-field :label="labels.groupId" v-model="memberGroupForm.groupId" :error-messages="errors.collect('groupId')" v-validate="'required|param|max:20'" data-vv-name="groupId" :data-vv-as="labels.groupId"></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-subheader class="queryLabel">{{labels.groupIdQuery}}</v-subheader>
                    <div class="subheading">{{memberGroupForm.groupId}}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field :label="labels.groupDesc" v-model="memberGroupForm.groupDesc" :error-messages="errors.collect('groupDesc')" v-validate="'entry|max:100'" data-vv-name="groupDesc" :data-vv-as="labels.groupDesc"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea :label="labels.groupDeclaration" v-model="memberGroupForm.groupDeclaration" :error-messages="errors.collect('groupDeclaration')" v-validate="'entry'" data-vv-name="groupDeclaration" :data-vv-as="labels.groupDeclaration" prepend-icon="mdi-comment-text" auto-grow></v-textarea>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-checkbox :label="labels.enableB2CReg" v-model="memberGroupForm.enableB2CReg" data-vv-name="enableB2CReg" :data-vv-as="labels.enableB2CReg"></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox :label="labels.restrictedGroup" v-model="memberGroupForm.restrictedGroup" data-vv-name="restrictedGroup" :data-vv-as="labels.restrictedGroup"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs5 v-if="memberGroupForm.enableB2CReg">
                    <v-text-field background-color="blue lighten-3" label="Registration Link" v-model="b2cRegistrationLink" outline readonly></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container>
            <v-btn color="primary" :loading="submitting" @click.native="doSaveMemberGroup">
              {{newMemberGroup? 'Save Member Group' : 'Update Member Group'}}
              <v-icon right>{{newMemberGroup? 'mdi-account-card-details' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-text>
        </form>
      </v-card>
    </page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      breadcrumb: [],
      labels: {
        memberGroup: 'Member Group Information',
        groupId: 'Group Id*',
        groupIdQuery: 'Group Id',
        groupDesc: 'Group Description',
        groupDeclaration: 'Group Declaration',
        enableB2CReg: 'Enabled for B2C Registration',
        restrictedGroup: 'Restricted Group'
      },
      memberGroupForm: {
        groupId: undefined,
        groupDesc: undefined,
        groupDeclaration: undefined,
        enableB2CReg: false,
        restrictedGroup: false,
        revision: undefined
      },
      menu: [],
      newMemberGroup: false,
      submitting: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName'
    ]),
    title() {
      if (this.newMemberGroup) {
        return 'New Member Group'
      } else {
        return 'Review Member Group'
      }
    },
    b2cRegistrationLink() {
      if (this.memberGroupForm.groupId && this.memberGroupForm.enableB2CReg) {
        return 'https://{Your B2C Website URL}/member/register/' + this.memberGroupForm.groupId
      }
      return ''
    }
  },
  methods: {
    async doInit() {
      if (this.$route.params.groupId !== 'new') {
        // Review
        this.newMemberGroup = false
        await this.reviewMemberGroup()
      } else {
        this.newMemberGroup = true
      }
    },
    async reviewMemberGroup() {
      const apiURI = this.$store.state.adminMember.menu.memberGroupGet
      if (apiURI) {
        try {
          const expand = {
            groupId: this.groupId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Member Group init
            this.memberGroupForm.groupId = data.usrMemberGrp.groupId
            this.memberGroupForm.groupDesc = data.usrMemberGrp.groupDesc
            this.memberGroupForm.groupDeclaration = data.usrMemberGrp.groupDeclaration
            this.memberGroupForm.enableB2CReg = data.usrMemberGrp.enableB2CReg
            this.memberGroupForm.restrictedGroup = data.usrMemberGrp.restrictedGroup
            this.memberGroupForm.revision = data.usrMemberGrp.revision
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSaveMemberGroup() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newMemberGroup) {
            this.doCreateMemberGroup()
          } else {
            this.doUpdateMemberGroup()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateMemberGroup() {
      const apiURI = this.$store.state.adminMember.menu.memberGroupCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.memberGroupForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'memberGroups' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doUpdateMemberGroup() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.memberGroupForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'memberGroups' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doQuery() {
      this.$router.push({ name: 'memberGroupQuery', params: { groupId: this.groupId } })
    }
  },
  mounted() {
    this.breadcrumb = this.derieveBreadcrumbByName('memberGroups')
    this.breadcrumb.push({
      name: 'memberGroupReview',
      text: this.title
    })
    if (this.groupId === 'new') {
      this.loading = false
    }
  },
  created() {
    if (this.groupId === 'new') {
      this.newMemberGroup = true
    } else {
      this.doInit()
    }
  },
  props: {
    groupId: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
